import React, { useState,useEffect } from "react";
import "./monthly-static-calendar.css";
import prevIcon from "../../assets/SVGs/prev-button.svg";
import nextIcon from "../../assets/SVGs/next-button.svg";
import screenIcon from "../../assets/SVGs/screen-icon.svg";
import sunIcon from "../../assets/SVGs/sun.svg";
import cloudIcon from "../../assets/SVGs/cloud.svg";
import { NavLink } from "react-router-dom";

const MonthlyStaticCalendar = ({ events, list ,filterEvents }) => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(
    new Date().toLocaleDateString("en-US")
  );
  const daysOfWeek = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
  const [selectedItems, setSelectedItems] = useState([]);
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();
  const today = new Date();

  const firstDayOfMonth = new Date(year, month, 1);
  const lastDayOfMonth = new Date(year, month + 1, 0);
  const lastDayOfPrevMonth = new Date(year, month, 0);

  const daysInMonth = lastDayOfMonth.getDate();
  const daysInPrevMonth = lastDayOfPrevMonth.getDate();

  const firstDayIndex = firstDayOfMonth.getDay();
  const lastDayIndex = lastDayOfMonth.getDay();

  const dates = [];

  for (let i = firstDayIndex; i > 0; i--) {
    dates.push({
      day: daysInPrevMonth - i + 1,
      currentMonth: false,
    });
  }

  for (let i = 1; i <= daysInMonth; i++) {
    dates.push({
      day: i,
      currentMonth: true,
      isToday:
        today.getDate() === i &&
        today.getMonth() === month &&
        today.getFullYear() === year,
    });
  }

  for (let i = 1; i < 7 - lastDayIndex; i++) {
    dates.push({
      day: i,
      currentMonth: false,
    });
  }

  const handlePrevMonth = () => {
    setCurrentDate(new Date(year, month - 1, 1));
  };

  const handleNextMonth = () => {
    setCurrentDate(new Date(year, month + 1, 1));
  };

  const handleDateClick = (date) => {
    setSelectedDate(date);
  };

  const transformApiData = (apiData) => {
    const getDayName = (dateString) => {
      const days = [
        "SUNDAY",
        "MONDAY",
        "TUESDAY",
        "WEDNESDAY",
        "THURSDAY",
        "FRIDAY",
        "SATURDAY",
      ];
      const date = new Date(dateString);
      return days[date.getDay()];
    };

    const getWeatherIcon = (day) => {
      // Mock logic to assign weather icon based on day
      if (day === "TOMORROW") return sunIcon;
      return cloudIcon; // Default
    };

    const getCircleColor = (day) => {
      // Mock logic for circle colors
      const colors = {
        MONDAY: "#3B82F6",
        TUESDAY: "#FBBF24",
        TOMORROW: "#EC4899",
      };
      return colors[day] || "#000000"; // Default black
    };

    const eventsByDate = {};

    // Group events by date
    apiData &&
      apiData.forEach((event) => {
        const startDate = new Date(
          event.start.dateTime ? event.start.dateTime : event.start.date
        );
        const formattedDate = startDate.toLocaleDateString("en-US");
        const dayName = getDayName(startDate);

        if (!eventsByDate[formattedDate]) {
          eventsByDate[formattedDate] = {
            day:
              dayName === new Date().toLocaleDateString("en-US")
                ? "TOMORROW"
                : dayName,
            date: formattedDate,
            temperature: "55°/40°", // Mock temperature
            weather: getWeatherIcon(dayName),
            circleColor: getCircleColor(dayName),
            events: [],
          };
        }

        eventsByDate[formattedDate].events.push({
          time: `${startDate.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })} - ${new Date(
            event.end.dateTime ? event.end.dateTime : event.end.date
          ).toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })}`,
          title: event.summary ? event.summary : "No Title",
          link: event.htmlLink || "",
        });
      });

    // Convert grouped data into an array
    return Object.values(eventsByDate);
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    const nextSelectedItems = checked
    ? [...selectedItems, name] 
    : selectedItems.filter((item) => item !== name);

    setSelectedItems(nextSelectedItems);

    filterEvents(nextSelectedItems);
  };


  const eventsData = events && transformApiData(events);
  const filteredEventsData =
    selectedDate &&
    eventsData &&
    eventsData.filter((event) => event.date === selectedDate);
  console.log("filteredEventsData", filteredEventsData);
  const eventList = [
    {
      id: 1,
      listName: "List 1",
    },
    {
      id: 2,
      listName: "List 2",
    },
    {
      id: 3,
      listName: "List 3",
    },
    {
      id: 4,
      listName: "List 4",
    },
  ];
  useEffect(() => {
    if(list){
      setSelectedItems(list.map((item) => item.id))
    }
  }, [list]);
  return (
    <div className="monthly-static-calendar-container">
      <div className="calendar-header">
        <span>
          {currentDate.toLocaleString("default", { month: "long" })}{" "}
          <span style={{ color: "red" }}> {year} </span>
        </span>
        <div className="next-prev-buttons">
          <button onClick={handlePrevMonth}>
            <img src={prevIcon} alt="" />
          </button>
          <button onClick={handleNextMonth}>
            <img src={nextIcon} alt="" />
          </button>
        </div>
      </div>
      <div className="calendar-grid">
        {daysOfWeek.map((day) => (
          <div key={day} className="calendar-day">
            {day}
          </div>
        ))}
        {dates.map((date, index) => (
          <div
            key={index}
            className={`calendar-date ${date.currentMonth ? "" : "disabled"} ${
              date.isToday ? "today" : ""
            } ${
              date.currentMonth &&
              selectedDate ===
                new Date(year, month, date.day).toLocaleDateString("en-US")
                ? "selected"
                : ""
            }`}
            style={{ cursor: "pointer" }}
            onClick={() =>
              handleDateClick(
                new Date(year, month, date.day).toLocaleDateString("en-US")
              )
            }
          >
            {date.day}
          </div>
        ))}
      </div>
      <div style={{height: "calc(100% - 275px)",}}>
      <div className="left-calendar-events-container">
        {filteredEventsData &&
          filteredEventsData.map((item, index) => (
            <div key={index}>
              <div className="left-calendar-events-header">
                <div className="left-calendar-events-header-items">
                  <p>{item.day}</p>
                  <p>{item.date}</p>
                </div>
                <div className="left-calendar-events-header-items">
                  <p>{item.temperature}</p>
                  <img src={item.weather} alt="sun-icon" />
                </div>
              </div>
              <div className="left-calendar-events-content-container">
                <div
                  style={{
                    backgroundColor: item.circleColor,
                    minWidth: "12px",
                  }}
                  className="circle"
                ></div>
                <div>
                  {item.events.map((events) => (
                    <div className="left-calendar-content-items">
                      <div className="left-calendar-events-content">
                        <p>{events.time}</p>
                        <img src={screenIcon} alt="screen-icon" />
                      </div>
                      <div className="description-para">
                        <p
                          style={{
                            fontSize: "16px",
                            color: "white",
                          }}
                        >
                          {events.title}
                        </p>
                      </div>
                      <NavLink to={"#"}>
                        <p> {events.link}</p>
                      </NavLink>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
      </div>
      <div className="left-calendar-events-container" style={{maxHeight: "calc(100% - 195px)",height:"100%"}}>
      <p className="calendar-list-heading">My calendars</p>
        {list &&
          list.map((item, index) => (
            <div key={index}>
              <div className="left-calendar-events-header-items">
              <input type="checkbox" name={item.id} id={item.id} 
                style={{
                  accentColor: item.backgroundColor, 
                  borderColor: item.backgroundColor,
                }} 
               onChange={handleCheckboxChange}
               checked={selectedItems && selectedItems.includes(item.id)}
               ></input>
               <label className="event-label-style" htmlFor={item.id}>{item.summary	}</label>
              </div>
            </div>
          ))}
      </div> 
      </div>
    </div>
  );
};

export default MonthlyStaticCalendar;

// const eventsData = [
//   {
//     day: "TOMORROW",
//     date: "2/28/2021",
//     temperature: "55°/40°",
//     weather: sunIcon,
//     circleColor: "#EC4899",
//     events: [
//       {
//         time: "8:30 - 9:00 AM",
//         title: "Visit to discuss improvements",
//         link: "https://zoom.us/j/1983475281",
//       },
//       {
//         time: "8:30 - 9:00 AM",
//         color: "blue",
//         title: "Presentation of new products and cost structure",
//         link: "",
//       },
//     ],
//   },
//   {
//     day: "MONDAY",
//     date: "3/1/2021",
//     temperature: "55°/40°",
//     weather: cloudIcon,
//     circleColor: "#3B82F6",
//     events: [
//       {
//         time: "8:30 - 9:00 AM",
//         title: "City Sales Pitch",
//         link: "https://zoom.us/j/1983475281",
//       },
//     ],
//   },
//   {
//     day: "TUESDAY",
//     date: "3/2/2021",
//     temperature: "55°/40°",
//     weather: cloudIcon,
//     circleColor: "#FBBF24",
//     events: [
//       {
//         time: "8:30 - 9:00 AM",
//         title: "Visit to discuss improvements",
//         link: "",
//       },
//     ],
//   },
// ];
